export default {
	text: {
		overflow: 'hidden',
		textOverflow: 'ellipsis',
	},
	tooltip: {
		wordBreak: 'break-all',
	},
};
